import Vue from 'vue'
import App from './App.vue'
import './quasar'
import router from './router'

import store from './store';

const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)

Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
